import React from 'react';
import { Globe, CheckCircle, Send, MapPin, Award, Users, Wrench } from 'lucide-react';
import './About.css';
import aboutimg from '../Images/About.jpg'
import vision from '../Images/vision.jpg'

const AboutPage = () => {
  const features = [
    {
      title: "Comprehensive Inventory",
      description: "for all major machine brands",
      icon: <Globe className="feature-icon" />
    },
    {
      title: "Assured Quality",
      description: "only genuine & performance-tested products",
      icon: <CheckCircle className="feature-icon" />
    },
    {
      title: "Quick Turnaround",
      description: "efficient logistics and support",
      icon: <Send className="feature-icon" />
    },
    {
      title: "Nationwide Shipping",
      description: "from metros to remote areas",
      icon: <MapPin className="feature-icon" />
    }
  ];

  const stats = [
    { number: "500+", label: "Happy Clients" },
    { number: "1000+", label: "Parts Available" },
    // { number: "10+", label: "Years Experience" },
    { number: "24/7", label: "Support" }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="hero-background-pattern"></div>
        <div className="hero-container">
          <div className="hero-content-wrapper">
            {/* Left Content */}
            <div className="hero-left">
              <div className="hero-badge">
                <Award className="badge-icon" />
                <span>India's Leading Parts Supplier</span>
              </div>
              
              {/* <h1 className="hero-title">
                About <span className="title-accent">ACGPL</span>
              </h1> */}
              <h1 className="hero-title">
                <span className="title-accent">Megapix Machinery</span>
              </h1>
              
              <p className="hero-subtitle">
                Your Trusted Partner in Heavy Equipment Solutions
              </p>
              
              <p className="hero-description">
                With <strong>over years of experience</strong>, Megapix Machinery Private Limited
 is a leading supplier of <strong>aftermarket and OEM-grade heavy equipment spare parts</strong> in India. We specialize in delivering reliable solutions that minimize downtime and maximize performance for construction and earthmoving machinery.
              </p>
              
              <div className="hero-stats">
                {stats.map((stat, index) => (
                  <div key={index} className="stat-card">
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Right Image */}
            <div className="hero-right">
              <div className="hero-image-container">
                <div className="image-wrapper">
                  <img 
                    src= {aboutimg}
                    alt="Heavy Equipment Parts and Machinery" 
                    className="hero-main-image"
                  />
                  <div className="image-decoration"></div>
                </div>
                
                <div className="floating-cards">
                  <div className="floating-card card-1">
                    <Wrench className="card-icon" />
                    <div className="card-content">
                      <div className="card-title">Premium Quality</div>
                      <div className="card-subtitle">OEM & Aftermarket Parts</div>
                    </div>
                  </div>
                  
                  <div className="floating-card card-2">
                    <Globe className="card-icon" />
                    <div className="card-content">
                      <div className="card-title">Nationwide</div>
                      <div className="card-subtitle">Shipping & Support</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Who We Are Section */}
      <div className="who-section">
        <div className="section-container">
          <div className="section-content">
            <div className="section-badge">
              <Users className="badge-icon" />
              <span>Our Story</span>
            </div>
            <h2 className="section-title">
              Who We Are
            </h2>
            <p className="section-description">
              Founded by industry experts, our company is driven by a passion for quality, innovation, and customer satisfaction. We believe in offering not just parts—but performance and peace of mind that keeps your operations running smoothly.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section">
        <div className="section-container">
          <div className="section-header">
            <div className="section-badge">
              <CheckCircle className="badge-icon" />
              <span>Why Choose Us</span>
            </div>
            <h2 className="section-title">
              What Sets Us Apart
            </h2>
            <p className="section-subtitle">
              We're committed to excellence in every aspect of our service
            </p>
          </div>
          
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon-container">
                  {feature.icon}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Vision Section */}
      {/* <div className="vision-section">
        <div className="section-container">
          <div className="vision-content">
            <div className="vision-text">
              <div className="section-badge vision-badge">
                <Globe className="badge-icon" />
                <span>Our Mission</span>
              </div>
              <h2 className="vision-title">
                Our Vision for the Future
              </h2>
              <p className="vision-description">
                To become India's most trusted source for heavy machinery parts through a commitment to quality, affordability, and customer satisfaction. We envision a future where equipment downtime is minimized and productivity is maximized.
              </p>
            </div>
            <div className="vision-image">
              <img 
                src={vision}
                alt="Heavy Equipment at Construction Site" 
                className="vision-img"
              />
            </div>
          </div>
        </div>
      </div> */}













      
    </div>
  );
};

export default AboutPage;